import { jsx as c } from "react/jsx-runtime";
import * as d from "react";
import { u as M, c as y } from "../index-BAFn5Hvf.js";
import { c as V, P as m } from "../index-RcgQH_g_.js";
import { c as T, R as E, I as F } from "../index-DSAktXEq.js";
import { P as L } from "../index-Bl3O8yTo.js";
import { u as $ } from "../index-BrDAPQgS.js";
import { u as k } from "../index-aOuX810t.js";
import { c as b } from "../clsx-OuTLNxxd.js";
var h = "Tabs", [D, le] = V(h, [
  T
]), S = T(), [G, p] = D(h), H = d.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: o,
      value: i,
      onValueChange: s,
      defaultValue: l,
      orientation: n = "horizontal",
      dir: x,
      activationMode: f = "automatic",
      ...u
    } = e, r = $(x), [a, g] = M({
      prop: i,
      onChange: s,
      defaultProp: l
    });
    return /* @__PURE__ */ c(
      G,
      {
        scope: o,
        baseId: k(),
        value: a,
        onValueChange: g,
        orientation: n,
        dir: r,
        activationMode: f,
        children: /* @__PURE__ */ c(
          m.div,
          {
            dir: r,
            "data-orientation": n,
            ...u,
            ref: t
          }
        )
      }
    );
  }
);
H.displayName = h;
var _ = "TabsList", C = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: o, loop: i = !0, ...s } = e, l = p(_, o), n = S(o);
    return /* @__PURE__ */ c(
      E,
      {
        asChild: !0,
        ...n,
        orientation: l.orientation,
        dir: l.dir,
        loop: i,
        children: /* @__PURE__ */ c(
          m.div,
          {
            role: "tablist",
            "aria-orientation": l.orientation,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
C.displayName = _;
var N = "TabsTrigger", z = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: o, value: i, disabled: s = !1, ...l } = e, n = p(N, o), x = S(o), f = W(n.baseId, i), u = w(n.baseId, i), r = i === n.value;
    return /* @__PURE__ */ c(
      F,
      {
        asChild: !0,
        ...x,
        focusable: !s,
        active: r,
        children: /* @__PURE__ */ c(
          m.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": r,
            "aria-controls": u,
            "data-state": r ? "active" : "inactive",
            "data-disabled": s ? "" : void 0,
            disabled: s,
            id: f,
            ...l,
            ref: t,
            onMouseDown: y(e.onMouseDown, (a) => {
              !s && a.button === 0 && a.ctrlKey === !1 ? n.onValueChange(i) : a.preventDefault();
            }),
            onKeyDown: y(e.onKeyDown, (a) => {
              [" ", "Enter"].includes(a.key) && n.onValueChange(i);
            }),
            onFocus: y(e.onFocus, () => {
              const a = n.activationMode !== "manual";
              !r && !s && a && n.onValueChange(i);
            })
          }
        )
      }
    );
  }
);
z.displayName = N;
var I = "TabsContent", R = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: o, value: i, forceMount: s, children: l, ...n } = e, x = p(I, o), f = W(x.baseId, i), u = w(x.baseId, i), r = i === x.value, a = d.useRef(r);
    return d.useEffect(() => {
      const g = requestAnimationFrame(() => a.current = !1);
      return () => cancelAnimationFrame(g);
    }, []), /* @__PURE__ */ c(L, { present: s || r, children: ({ present: g }) => /* @__PURE__ */ c(
      m.div,
      {
        "data-state": r ? "active" : "inactive",
        "data-orientation": x.orientation,
        role: "tabpanel",
        "aria-labelledby": f,
        hidden: !g,
        id: u,
        tabIndex: 0,
        ...n,
        ref: t,
        style: {
          ...e.style,
          animationDuration: a.current ? "0s" : void 0
        },
        children: g && l
      }
    ) });
  }
);
R.displayName = I;
function W(e, t) {
  return `${e}-trigger-${t}`;
}
function w(e, t) {
  return `${e}-content-${t}`;
}
var K = H, B = C, A = z, P = R;
const j = "320px", q = "600px", O = "1025px", J = "_isVisuallyHidden_lhpgc_51", Q = "_tabsList_lhpgc_63", U = "_tabsTrigger_lhpgc_80", X = "_tabsContent_lhpgc_125", v = {
  mobile: j,
  "mobile-wide": "480px",
  tablet: q,
  "tablet-wide": "800px",
  desktop: O,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: J,
  tabsList: Q,
  tabsTrigger: U,
  tabsContent: X
}, de = K, Y = d.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ c(
  B,
  {
    ref: o,
    className: b(v.tabsList, e),
    ...t
  }
));
Y.displayName = B.displayName;
const Z = d.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ c(
  A,
  {
    ref: o,
    className: b(v.tabsTrigger, e),
    ...t
  }
));
Z.displayName = A.displayName;
const ee = d.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ c(
  P,
  {
    ref: o,
    className: b(v.tabsContent, e),
    ...t
  }
));
ee.displayName = P.displayName;
export {
  de as Tabs,
  ee as TabsContent,
  Y as TabsList,
  Z as TabsTrigger
};
